import React from "react";
import Link from "next/link";
import { Button } from "@/components/common/Button";
import style from "./CTA.module.scss";
const CTA = () => {
  return <section className={style.cta} data-sentry-component="CTA" data-sentry-source-file="CTA.tsx">
      <div className={style.cta__text}>
        <div>Make your materials better</div>
        <p>
          Add editable and trackable QR Codes on anything you want with full branding and
          customization features.
        </p>
      </div>

      <Link href={"/register"} data-sentry-element="Link" data-sentry-source-file="CTA.tsx">
        <Button variant="primary" title="Sign up now" className={style.btn} data-sentry-element="Button" data-sentry-source-file="CTA.tsx" />
      </Link>
    </section>;
};
export default CTA;